// Single source of truth for the version string shown in the avatar dropdown.
// Keep in sync with package.json on each release. A follow-up can wire this to
// process.env.REACT_APP_VERSION at build time if manual updates get tedious.
export const APP_VERSION = '1.0.0';
